module.exports = __webpack_public_path__ + "static/img/1-1Z524151K49E.722af3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z524151K49E.jpg
// module id = +6eH
// module chunks = 0